import { render, staticRenderFns } from "./questionnList.vue?vue&type=template&id=41520e03&scoped=true&"
import script from "./questionnList.vue?vue&type=script&lang=js&"
export * from "./questionnList.vue?vue&type=script&lang=js&"
import style0 from "./questionnList.vue?vue&type=style&index=0&id=41520e03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41520e03",
  null
  
)

export default component.exports